import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { resolveManageLinkByShortCode } from '../../shared/api/bookingApi.js';

/**
 * Компонент для обработки коротких ссылок /r/:shortCode
 * Редиректит на страницу управления записью с нужными параметрами
 */
export default function ShortLinkRedirect() {
  const { shortCode } = useParams<{ shortCode: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!shortCode) {
      navigate('/404', { replace: true });
      return;
    }

    let cancelled = false;

    resolveManageLinkByShortCode(shortCode)
      .then(({ appointmentId, token, masterSlug }) => {
        if (cancelled) return;
        const params = new URLSearchParams({ appointmentId, token });
        navigate(`/booking/${masterSlug}/manage?${params.toString()}`, { replace: true });
      })
      .catch(() => {
        if (cancelled) return;
        navigate('/404', { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [shortCode, navigate]);

  return null; // Компонент только для редиректа
}
